'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dImage from "./mealorama.-Image.js";
var $p;
/** @constructor */
function $c_Lmealorama_Image$() {
}
export { $c_Lmealorama_Image$ as $c_Lmealorama_Image$ };
$p = $c_Lmealorama_Image$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Image$;
/** @constructor */
function $h_Lmealorama_Image$() {
}
export { $h_Lmealorama_Image$ as $h_Lmealorama_Image$ };
$h_Lmealorama_Image$.prototype = $p;
$p.m = (function() {
  return "Image";
});
$p.aSh = (function(x$0) {
  var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(0));
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uJ(x$0.g(1));
  return new $j_mealorama$002e$002dImage.$c_Lmealorama_Image($x_2.l, $x_2.h, $x_1.l, $x_1.h, x$0.g(2), x$0.g(3), x$0.g(4));
});
var $d_Lmealorama_Image$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Image$, "mealorama.Image$", ({
  FQ: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_Image$ as $d_Lmealorama_Image$ };
var $n_Lmealorama_Image$;
function $m_Lmealorama_Image$() {
  if ((!$n_Lmealorama_Image$)) {
    $n_Lmealorama_Image$ = new $c_Lmealorama_Image$();
  }
  return $n_Lmealorama_Image$;
}
export { $m_Lmealorama_Image$ as $m_Lmealorama_Image$ };
//# sourceMappingURL=mealorama.-Image$.js.map
